import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id"];
import PropTypes from 'prop-types';
import React from 'react';
import { SliderLabel } from '../SliderLabel/SliderLabel';
import { SliderThumb } from '../SliderThumb/SliderThumb';
import { SliderTrack } from '../SliderTrack/SliderTrack';
import { StyledSlider } from './Slider.styles';

/**
 * A custom slider component built on top of
 * [`react-slider`](https://github.com/zillow/react-slider)
 * (see the [example page](https://zillow.github.io/react-slider/)
 * for full props documentation).
 *
 * @since 6.12.0
 */
export var Slider = function Slider(_ref) {
  var id = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledSlider, _extends({
    id: id,
    thumbClassName: id + "-thumb"
  }, props));
};
Slider.displayName = 'Slider';
Slider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The id of the slider. This is also used to generate ids and classNames for
   * accessibility purposes.
   */
  id: PropTypes.string.isRequired,
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  min: PropTypes.number,
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  max: PropTypes.number,
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  step: PropTypes.number,
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  onChange: PropTypes.func,
  /** @ignore */
  renderThumb: PropTypes.func,
  /** @ignore */
  renderTrack: PropTypes.func,
  /** @ignore */
  pearling: PropTypes.bool
} : {};
Slider.defaultProps = {
  renderThumb: function renderThumb(props, state) {
    return /*#__PURE__*/React.createElement(SliderThumb, _extends({}, props, {
      "aria-labelledby": props.key
    }), /*#__PURE__*/React.createElement(SliderLabel, {
      id: props.key
    }, props['aria-valuetext'] || state.valueNow));
  },
  renderTrack: function renderTrack(props, state) {
    return /*#__PURE__*/React.createElement(SliderTrack, _extends({}, props, {
      trackState: state
    }));
  },
  pearling: true
};